import { colours } from './colours.js';

/** @param {number} px */
const pxTorem = (px) => px / 16;


const createSpacing = (px) => ({ [`${px}`]: `${pxTorem(px)}rem` });


const createWidth = (colCount, prefix = '') => Array(colCount)
    .fill(null)
    .map((_, i) => ({ [`${prefix}${i + 1}/${colCount}`]: `${(i + 1) / colCount * 100}%` }))
    .reduce((pV, cV) => {
        return { ...cV, ...pV };
    }, {});


const extendColours = () => {
    const classes = {};

    const {
        swatch: coloursSwatch,
        ...coloursRest
    } = colours;

    Object.entries(coloursSwatch).forEach((item) => {
        classes[item[0]] = item[1];
    });

    Object.entries(coloursRest).forEach((group) => {
        Object.keys(group[1]).forEach(key => {
            classes[key] = `var(--${key})`;
        });
    });

    return classes;
};


export {
    createSpacing,
    createWidth,
    extendColours,
    pxTorem
};
